import { setCookie, getCookie } from '../utils/cookies.js'

function updateGtagConsent() {
    /* global gtag */
    gtag('consent', 'update', {
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'personalization_storage': 'granted',
        'analytics_storage': 'granted'
    })
}

export default function websiteAgreement() {
    const dialog = document.getElementById('dialog-agreement')
    if (!dialog) {
        return
    }
    const agreed = getCookie('agreement')
    if (agreed) {
        updateGtagConsent()
        return
    }
    setTimeout(() => { dialog.showModal()}, 1000)

    const agreementButton = document.getElementById('agreement-button')
    agreementButton.addEventListener('click', () => {
        setCookie('agreement', 'true', 365)
        dialog.close()
        updateGtagConsent()
    })
}
